import React from 'react';
import PropTypes from 'prop-types';

import { OXYGEN_ACCOMMODATION_VALUE } from '../../../../constants/constants';
import OxygenImportantInfo from '../../OxygenImportantInfo/OxygenImportantInfo';
import styles from '../index.module.css';

const isCompanionRideOption = (optionValue) =>
  typeof optionValue === 'string' && /companion/i.test(optionValue);

const filterCompanionRideOptions = (options = []) =>
  options.filter((option) => !isCompanionRideOption(option?.value ?? option));

const renderAdditionalRideRequestOpts = (options) =>
  options?.length > 0 && (
    <ul className={styles.additionalOptions}>
      {options.map((option) => (
        <li key={option.value || option}>{option.value}</li>
      ))}
    </ul>
  );

const rendervehicleInformationRadioOpts = (options) => (
  <ul className={styles.additionalOptions}>
    {options
      .filter((option) => option.value)
      .map((option) => (
        <li key={option.name}>{option.name}</li>
      ))}
  </ul>
);

export const AdditionalOptions = ({ rideOptions = [], vehicleInformationRadioOpts }) => {
  const visibleRideOptions = filterCompanionRideOptions(rideOptions);
  const hasVehicleOpts = vehicleInformationRadioOpts?.some((o) => o.value);
  const showSection = visibleRideOptions.length > 0 || hasVehicleOpts;

  if (!showSection) {
    return null;
  }

  return (
    <>
      <p className={styles.recordTitle}>Additional Rider Transportation Needs:</p>
      {renderAdditionalRideRequestOpts(visibleRideOptions)}
      {rendervehicleInformationRadioOpts(vehicleInformationRadioOpts)}
      {/* {rideOptions.some((o) => o.value === OXYGEN_ACCOMMODATION_VALUE) && (
        <OxygenImportantInfo />
      )} */}
    </>
  );
};

AdditionalOptions.propTypes = {
  rideOptions: PropTypes.array,
  vehicleInformationRadioOpts: PropTypes.array,
};
